module.exports = __webpack_public_path__ + "img/attachFIleIcon.435d6aba.svg";